import React from 'react';
import { Mercury } from '@repo/types/Models';

type Permissions = {
  [key in Mercury.Models.RoleResourceAction['name']]?: true;
};

type Resources = {
  [key in Mercury.Models.RoleResource['resourceId']]?: Permissions;
};

function remapResources(roleResources?: Mercury.Models.RoleResource[]): Resources | undefined {
  if (!roleResources || roleResources.length === 0) {
    return undefined;
  }

  const resources: Resources = {};

  for (const roleResource of roleResources) {
    const resource = resources[roleResource.resourceId] ?? {};
    for (const action of roleResource.actions ?? []) {
      if (action.value === 'true') {
        resource[action.name] = true;
      }
    }
    resources[roleResource.resourceId] = resource;
  }

  return resources;
}

export const POLICIES = {
  'accounts:index': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.accounts?.INDEX || false,
  'accounts:show': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.accounts?.SHOW || false,
  'accounts:count': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.accounts?.COUNT || false,
  'accounts:create': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.accounts?.CREATE || false,
  'accounts:update': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.accounts?.UPDATE || false,
  'accounts:delete': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.accounts?.DELETE || false,

  'account_addresses:index': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.account_addresses?.INDEX || false,
  'account_addresses:show': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.account_addresses?.SHOW || false,
  'account_addresses:count': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.account_addresses?.COUNT || false,
  'account_addresses:create': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.account_addresses?.CREATE || false,
  'account_addresses:update': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.account_addresses?.UPDATE || false,
  'account_addresses:delete': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.account_addresses?.DELETE || false,

  'account_primary_contacts:index': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.account_primary_contacts?.INDEX || false,
  'account_primary_contacts:show': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.account_primary_contacts?.SHOW || false,
  'account_primary_contacts:count': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.account_primary_contacts?.COUNT || false,
  'account_primary_contacts:create': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.account_primary_contacts?.CREATE || false,
  'account_primary_contacts:update': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.account_primary_contacts?.UPDATE || false,
  'account_primary_contacts:delete': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.account_primary_contacts?.DELETE || false,

  'account_allowed_access_ips:index': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.account_allowed_access_ips?.INDEX || false,
  'account_allowed_access_ips:show': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.account_allowed_access_ips?.SHOW || false,
  'account_allowed_access_ips:count': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.account_allowed_access_ips?.COUNT || false,
  'account_allowed_access_ips:create': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.account_allowed_access_ips?.CREATE || false,
  'account_allowed_access_ips:update': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.account_allowed_access_ips?.UPDATE || false,
  'account_allowed_access_ips:delete': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.account_allowed_access_ips?.DELETE || false,

  'api_keys:index': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.api_keys?.INDEX || false,
  'api_keys:show': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.api_keys?.SHOW || false,
  'api_keys:count': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.api_keys?.COUNT || false,
  'api_keys:create': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.api_keys?.CREATE || false,
  'api_keys:update': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.api_keys?.UPDATE || false,
  'api_keys:delete': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.api_keys?.DELETE || false,
  'api_keys:impersonate': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.api_keys?.IMPERSONATE || false,

  'csp_brands:index': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.csp_brands?.INDEX || false,
  'csp_brands:show': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.csp_brands?.SHOW || false,
  'csp_brands:count': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.csp_brands?.COUNT || false,
  'csp_brands:create': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.csp_brands?.CREATE || false,
  'csp_brands:update': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.csp_brands?.UPDATE || false,
  'csp_brands:delete': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.csp_brands?.DELETE || false,

  'csp_campaigns:index': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.csp_campaigns?.INDEX || false,
  'csp_campaigns:show': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.csp_campaigns?.SHOW || false,
  'csp_campaigns:count': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.csp_campaigns?.COUNT || false,
  'csp_campaigns:create': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.csp_campaigns?.CREATE || false,
  'csp_campaigns:update': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.csp_campaigns?.UPDATE || false,
  'csp_campaigns:delete': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.csp_campaigns?.DELETE || false,

  'dids:index': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.dids?.INDEX || false,
  'dids:show': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.dids?.SHOW || false,
  'dids:count': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.dids?.COUNT || false,
  'dids:create': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.dids?.CREATE || false,
  'dids:update': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.dids?.UPDATE || false,
  'dids:delete': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.dids?.DELETE || false,
  'dids:export': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.dids?.EXPORT || false,

  'messaging_auto_responses:index': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.messaging_auto_responses?.INDEX || false,
  'messaging_auto_responses:show': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.messaging_auto_responses?.SHOW || false,
  'messaging_auto_responses:count': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.messaging_auto_responses?.COUNT || false,
  'messaging_auto_responses:create': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.messaging_auto_responses?.CREATE || false,
  'messaging_auto_responses:update': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.messaging_auto_responses?.UPDATE || false,
  'messaging_auto_responses:delete': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.messaging_auto_responses?.DELETE || false,

  'message_requests:index': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.message_requests?.INDEX || false,
  'message_requests:show': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.message_requests?.SHOW || false,
  'message_requests:count': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.message_requests?.COUNT || false,

  'mms_requests:index': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.mms_requests?.INDEX || false,
  'mms_requests:show': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.mms_requests?.SHOW || false,
  'mms_requests:count': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.mms_requests?.COUNT || false,
  'mms_requests:create': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.mms_requests?.CREATE || false,
  'mms_requests:update': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.mms_requests?.UPDATE || false,
  'mms_requests:delete': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.mms_requests?.DELETE || false,
  'mms_requests:export': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.mms_requests?.EXPORT || false,

  'sms_requests:index': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.sms_requests?.INDEX || false,
  'sms_requests:show': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.sms_requests?.SHOW || false,
  'sms_requests:count': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.sms_requests?.COUNT || false,
  'sms_requests:create': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.sms_requests?.CREATE || false,
  'sms_requests:update': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.sms_requests?.UPDATE || false,
  'sms_requests:delete': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.sms_requests?.DELETE || false,
  'sms_requests:export': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.sms_requests?.EXPORT || false,

  'messaging_optout_items:index': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.messaging_optout_items?.INDEX || false,
  'messaging_optout_items:show': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.messaging_optout_items?.SHOW || false,
  'messaging_optout_items:count': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.messaging_optout_items?.COUNT || false,

  'switches:index': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.switches?.INDEX || false,
  'switches:show': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.switches?.SHOW || false,
  'switches:count': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.switches?.COUNT || false,
  'switches:create': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.switches?.CREATE || false,
  'switches:update': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.switches?.UPDATE || false,
  'switches:delete': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.switches?.DELETE || false,

  'roles:index': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.roles?.INDEX || false,
  'roles:show': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.roles?.SHOW || false,

  'user:index': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.users?.INDEX || false,
  'user:show': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.users?.SHOW || false,
  'user:create': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.users?.CREATE || false,
  'user:update': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.users?.UPDATE || false,
  'user:delete': (user: Mercury.Models.User) =>
    remapResources(user.role.resources)?.users?.DELETE || false,
};

type AuthorizationProps = {
  children: React.ReactNode;
  policyCheck: boolean;
  fallbackView?: React.ReactNode;
};

export const Authorization = ({ children, fallbackView, policyCheck }: AuthorizationProps) => {
  return <>{policyCheck ? children : fallbackView ? fallbackView : null}</>;
};
